// This has to be defined in a separate file
// https://github.com/vitejs/vite/issues/3301#issuecomment-1192661323

import { ComposeClient } from "@composedb/client";
import { createContext } from "react";

type CeramicContextValue = {
  client: ComposeClient;
  isAuthenticated: boolean;
  connectWallet: any;
  disconnectWallet: import("@tanstack/react-query").UseMutateFunction<
    void,
    Error,
    void,
    unknown
  >;
  authenticateCeramic: () => Promise<void>;
  revokeCeramic: () => void;
  logout: () => void;
  address: string | undefined;
  isConnected: boolean;
};

export const CeramicContext = createContext<CeramicContextValue | undefined>(
  undefined
);
